const PathDefinition={
  ROOT:                     {path: '/',                               },

  INTRO:                    {path: '/',                               },
}

export default PathDefinition